import { api } from './index'
import type { ApiResponse } from './index'
import type { User, AuthTokens, QrGenerateResponse, QrStatusResponse } from '@asset-manager/shared'

export interface LoginResponse {
  user: User
  tokens: AuthTokens
}

export const authApi = {
  // 发送邮箱验证码
  sendEmailCode: (email: string): Promise<ApiResponse> =>
    api.post('/api/auth/send-email-code', { email }),

  // 发送短信验证码
  sendSmsCode: (phone: string): Promise<ApiResponse> =>
    api.post('/api/auth/send-sms-code', { phone }),

  // 邮箱验证码登录
  verifyEmail: (email: string, code: string): Promise<ApiResponse<LoginResponse>> =>
    api.post('/api/auth/verify-email', { email, code }),

  // 手机验证码登录
  verifyPhone: (phone: string, code: string): Promise<ApiResponse<LoginResponse>> =>
    api.post('/api/auth/verify-phone', { phone, code }),

  // 刷新token
  refreshToken: (refreshToken: string): Promise<ApiResponse<{ tokens: AuthTokens }>> =>
    api.post('/api/auth/refresh', { refreshToken }),

  // 登出
  logout: (refreshToken: string): Promise<ApiResponse> =>
    api.post('/api/auth/logout', { refreshToken }),

  // 登出所有设备
  logoutAll: (): Promise<ApiResponse> =>
    api.post('/api/auth/logout-all'),

  // 获取当前用户信息（含 role，用于刷新本地缓存）
  getCurrentUser: (): Promise<ApiResponse<{ user: User }>> =>
    api.get('/api/auth/me'),

  /**
   * 生成扫码登录会话
   *
   * 不传请求体：设备摘要由后端从 User-Agent 归纳，避免前端伪造。
   * 响应的 `qrImage` 为微信小程序码 data URL；缺失表示微信接口降级，
   * 调用方需回退渲染 `qr_login:<uuid>` 文本二维码。
   * Requirements: 1.4
   */
  generateQrCode: (): Promise<ApiResponse<QrGenerateResponse>> =>
    api.post('/api/auth/qr/generate'),

  /**
   * 轮询扫码登录状态
   *
   * 响应是六态判别联合（pending / scanned / confirmed / cancelled / expired / consumed），
   * 仅 `confirmed` 携带 `tokens` 与 `user`，且只在首次轮询下发（会话随即删除）。
   * Requirements: 6.1
   */
  getQrStatus: (uuid: string): Promise<ApiResponse<QrStatusResponse>> =>
    api.get('/api/auth/qr/status', { params: { uuid } })
}